import { c as _c } from "react/compiler-runtime";
import { HotelListHeaderTitlePropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelCityTitle: FC<HotelListHeaderTitlePropertiesType> = t0 => {
  const $ = _c(6);
  const {
    city,
    totalItem,
    hasCityPrefix: t1,
    loading
  } = t0;
  const hasCityPrefix = t1 === undefined ? true : t1;
  const router = useRouter();
  let t2;
  if ($[0] !== city || $[1] !== hasCityPrefix || $[2] !== loading || $[3] !== router || $[4] !== totalItem) {
    t2 = <div className="text-on-surface-high-emphasis text-body-2 w-full truncate pt-5 lg:pt-0 lg:font-medium" data-testid="header_title">{process.env.NEXT_PUBLIC_APP_NAME === "tour" ? loading ? <h2 className="inline">در جستجوی تور‌های {city} ...</h2> : <><span>{numberConvert(totalItem, {
            locale: "fa"
          })}{" "}</span><h2 className="inline">تور {city}</h2></> : city ? hasCityPrefix ? <><span>{numberConvert(totalItem, {
            locale: router.locale
          })}{" "}</span><h2 className="inline">اقامتگاه در {city}</h2></> : <><span>{numberConvert(totalItem, {
            locale: router.locale
          })} </span><h2 className="inline">اقامتگاه</h2></> : <div className="h-6"><Skeleton shape="rectangle" /></div>}</div>;
    $[0] = city;
    $[1] = hasCityPrefix;
    $[2] = loading;
    $[3] = router;
    $[4] = totalItem;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};